import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "hooks/useAuth";
import { useAppDispatch } from "hooks/useAppStore";
import { logout, stopImpersonation } from "store/slices/authSlice";
import { fetchUser } from "api";
import * as api from "api";

// ─── Nav icon components ──────────────────────────────────────────────────────

function IconHome()           { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>; }
function IconAddNew()         { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" /></svg>; }
function IconPartners()       { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>; }
function IconLogs()           { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>; }
function IconUsers()          { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>; }
function IconChangeRequests() { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" /></svg>; }
function IconTools()          { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><circle cx="12" cy="12" r="3" strokeWidth={2} /></svg>; }
function IconAccount()        { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>; }
function IconSchedules()      { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><line x1="16" y1="2" x2="16" y2="6" strokeWidth={2} strokeLinecap="round" /><line x1="8" y1="2" x2="8" y2="6" strokeWidth={2} strokeLinecap="round" /><line x1="3" y1="10" x2="21" y2="10" strokeWidth={2} strokeLinecap="round" /></svg>; }
function IconHistory()        { return <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>; }

// ─── Nav item type ────────────────────────────────────────────────────────────

interface NavItem {
  to:    string;
  label: string;
  icon:  React.ReactNode;
}

// ─── Role display labels ──────────────────────────────────────────────────────

const ROLE_LABELS: Record<string, string> = {
  bridge13_admin:   "Admin",
  bridge13_courier: "Courier",
  partner:          "Partner",
};

// ─── Layout ───────────────────────────────────────────────────────────────────

export default function AppLayout() {
  const { isAdmin, isCourier, isPartner, userName, userId, role, impersonating, adminSnapshot } = useAuth();
  const dispatch    = useAppDispatch();
  const navigate    = useNavigate();
  const queryClient = useQueryClient();
  const [menuOpen, setMenuOpen] = useState(false);

  // Fetch current user for email + profile photo (already cached by AccountPage)
  const { data: currentUser } = useQuery({
    queryKey: ["contactUser", userId],
    queryFn:  () => fetchUser(userId!),
    enabled:  !!userId,
  });

  const handleLogout = async () => {
    try { await api.logout(); } catch { /* no-op */ }
    dispatch(logout());
    navigate("/login");
  };

  const adminNav: NavItem[] = [
    { to: "/",                label: "Home",            icon: <IconHome /> },
    { to: "/add-new",         label: "Add new",         icon: <IconAddNew /> },
    { to: "/partners",        label: "Partners",        icon: <IconPartners /> },
    { to: "/logs",            label: "Logs",            icon: <IconLogs /> },
    { to: "/users",           label: "Users",           icon: <IconUsers /> },
    { to: "/change-requests", label: "Change requests", icon: <IconChangeRequests /> },
    { to: "/tools",           label: "Tools",           icon: <IconTools /> },
    { to: "/account",         label: "Account",         icon: <IconAccount /> },
  ];

  const courierNav: NavItem[] = [
    { to: "/",        label: "Home",    icon: <IconHome /> },
    { to: "/partners",label: "Partners",icon: <IconPartners /> },
    { to: "/account", label: "Account", icon: <IconAccount /> },
  ];

  const partnerNav: NavItem[] = [
    { to: "/",       label: "Home",            icon: <IconHome /> },
    { to: "/info",   label: "Info & Schedules", icon: <IconSchedules /> },
    { to: "/history",label: "History",          icon: <IconHistory /> },
    { to: "/account",label: "Account",          icon: <IconAccount /> },
  ];

  const navItems = isAdmin ? adminNav : isCourier ? courierNav : partnerNav;

  // Build initials for avatar fallback
  const initials = userName
    ? userName.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
    : "?";

  return (
    <div className="flex flex-col h-dvh bg-gray-50">
      {/* Impersonation banner */}
      {impersonating && (
        <div className="flex items-center justify-between bg-amber-400 px-4 py-2 text-xs font-medium text-amber-900 shrink-0">
          <span>
            Assuming persona of <strong>{userName}</strong> — changes affect real data
          </span>
          <button
            onClick={() => { dispatch(stopImpersonation()); queryClient.clear(); }}
            className="ml-4 rounded border border-amber-700 bg-amber-50 px-2 py-0.5 text-amber-900 hover:bg-white transition-colors"
          >
            Exit ({adminSnapshot?.userName})
          </button>
        </div>
      )}

      {/* Mobile top header */}
      <header className="md:hidden flex items-center justify-between bg-white border-b border-gray-200 px-4 py-3 shrink-0">
        <button
          onClick={() => setMenuOpen(true)}
          className="p-2 -ml-2 text-gray-500 hover:text-gray-700 transition-colors"
          aria-label="Open navigation menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        <span className="text-base font-semibold text-brand-600">Bridge 13</span>
        <div className="w-10" aria-hidden="true" />
      </header>

      <div className="flex flex-1 min-h-0">
        {/* Mobile backdrop */}
        {menuOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/40 md:hidden"
            onClick={() => setMenuOpen(false)}
            aria-hidden="true"
          />
        )}

        {/* Sidebar */}
        <aside
          className={[
            "fixed inset-y-0 left-0 z-50 w-72 flex flex-col bg-white border-r border-gray-200 transition-transform duration-200",
            "md:relative md:inset-auto md:w-56 md:shrink-0 md:translate-x-0",
            menuOpen ? "translate-x-0" : "-translate-x-full",
          ].join(" ")}
        >
          {/* Desktop logo */}
          <div className="hidden md:block px-5 py-5 border-b border-gray-100">
            <span className="text-lg font-semibold text-brand-600">Bridge 13</span>
            <p className="text-xs text-gray-400 mt-0.5">Food rescue logistics</p>
          </div>

          {/* Mobile drawer header */}
          <div className="flex items-center justify-between px-4 py-4 border-b border-gray-100 md:hidden">
            <div>
              <span className="text-base font-semibold text-brand-600">Bridge 13</span>
              <p className="text-xs text-gray-400">Food rescue logistics</p>
            </div>
            <button
              onClick={() => setMenuOpen(false)}
              className="p-2 -mr-2 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Close navigation menu"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Nav */}
          <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
            {navItems.map(({ to, label, icon }) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 px-3 py-3 md:py-2 rounded-lg text-sm transition-colors ${
                    isActive
                      ? "bg-brand-50 text-brand-600 font-medium"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                  }`
                }
              >
                {icon}
                {label}
              </NavLink>
            ))}
          </nav>

          {/* User footer */}
          <div className="px-4 py-4 border-t border-gray-100">
            <div className="flex items-center gap-3 mb-3">
              {/* Avatar */}
              {currentUser?.profile_photo_url ? (
                <img
                  src={currentUser.profile_photo_url}
                  alt={userName ?? ""}
                  className="w-9 h-9 rounded-full object-cover shrink-0"
                />
              ) : (
                <div className="w-9 h-9 rounded-full bg-brand-100 text-brand-700 flex items-center justify-center text-xs font-semibold shrink-0">
                  {initials}
                </div>
              )}

              {/* Name + email + role */}
              <div className="min-w-0">
                <p className="text-xs font-medium text-gray-800 truncate">{userName}</p>
                {currentUser?.email && (
                  <p className="text-xs text-gray-400 truncate">{currentUser.email}</p>
                )}
                {role && (
                  <p className="text-xs text-gray-400">{ROLE_LABELS[role] ?? role}</p>
                )}
              </div>
            </div>

            <button
              onClick={handleLogout}
              className="text-xs text-gray-400 hover:text-gray-700 transition-colors"
            >
              Sign out
            </button>
          </div>
        </aside>

        {/* Main content */}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
